import { onBeforeUnmount, ref, watch } from 'vue';

export const useElementHeight = (elementRef) => {
  const height = ref(0);
  let observer = null;

  const disconnect = () => {
    observer?.disconnect();
    observer = null;
  };

  watch(
    elementRef,
    (element) => {
      disconnect();
      if (!element) return;

      observer = new ResizeObserver(() => {
        height.value = element.offsetHeight;
      });
      observer.observe(element);
    },
    { immediate: true, flush: 'post' }
  );

  onBeforeUnmount(disconnect);

  return height;
};
